// Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
// tempor incididunt ut labore et dolore magna aliqua.

console.log("Lorem Ipsum");
console.log("Lorem Ipsum");
console.log("Lorem Ipsum");
console.log("Lorem Ipsum");
console.log("Lorem Ipsum");
console.log("Lorem Ipsum");